// if (window._rails_loaded) throw 'already loaded';
// import "../stylesheets/howmuch/howmuch";
//require '../shared/spree/frontend'

import $ from "../shared/jquery-global";

import RailsUjs from "@rails/ujs";
import { Turbo } from "@hotwired/turbo-rails"
Turbo.setFormMode('optin')

import "../shared/spree/frontend";
import "sticky-kit/dist/sticky-kit";
import LocalTime from "local-time";
import "../shared/set-timezone";
import "../shared/set-csrf";

import "../shared/frontend";
import "../shared/cloudinary";
//require './backend'
import CollapsibleLists from "collapsible-lists/CollapsibleLists.src";

//require('../howmuch/styles')
import "smartbanner.js/dist/smartbanner";
// import "@materializecss/materialize/dist/js/materialize";
import { FormSelect, Carousel, Sidenav, Collapsible, Tabs, Dropdown} from "@materializecss/materialize";

import { initializeSliderCarousel } from "../shared/common";
import { documentOn, elementParents, elementsOnEvent, toggle } from "../shared/jquery-alternative";
import { setCsrfTokenFromCookie } from "../shared/set-csrf";

LocalTime.start();
document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelector("form[data-remote=true]")) {
    RailsUjs.start(); //TOOD Added back, as its required for: http://127.0.0.1:3000/stores/Sauda-Sulf-F11/checkout/page. Was previously creating issues maybe?
  }  
})

//used for rails js
window.Collapsible = Collapsible;
window.FormSelect = FormSelect;

document.addEventListener("turbo:load", function() {
  setCsrfTokenFromCookie();
  RailsUjs.refreshCSRFTokens();
  let elems = document.querySelectorAll(".sidenav");
  if (elems.length > 0) Sidenav.init(elems, {});

  elems = document.querySelectorAll('.dropdown-trigger');
  if (elems.length > 0) Dropdown.init(elems);

  // M.updateTextFields();

  if(document.querySelectorAll(".tabs").length > 0) {
    Tabs.init(document.querySelectorAll(".tabs"), {});
  }

  elems = document.querySelectorAll(".btnMenuToggle");
  elems.forEach(elem => {
    elem.onclick = function(e) {
      const target = this.getAttribute("data-target");
      const elem = document.querySelector(`#${ target }`);
      const instance = Sidenav.getInstance(elem);
      if (instance.isOpen) {
        setTimeout(() => instance.close(), 50);
      }
    };
  });

  if(document.querySelectorAll(".products-carousel").length > 0) {
    Carousel.init(document.querySelectorAll(".products-carousel"));
  }
  initializeSliderCarousel();

  // M.AutoInit();

  FormSelect.init(document.querySelectorAll("select"), {});
});

document.addEventListener("turbo:load", function() {
  $("#order-summary-box").stick_in_parent({
    offset_top: 80,
  });

  documentOn("click", "#card-alert a", function() {
    const parents = elementParents(this, "#card-alert");
    parents.forEach(parent => {
      parent.classList.add('fade-out')
    })
  });

  elementsOnEvent(".cat-menu > li a", "click", function() {
    toggle(this.parentNode.querySelector("ul"))
  });
  CollapsibleLists.apply();
});
